import React from "react";
import { IPlacementWorksheetUnitOccupant } from "../../services/PlacementWorksheetApi";

import { PopupContext } from "./context";

export const PopupProvider: React.FC = (props) => {
  const [selectedResidents, setSelectedResidents] = React.useState<IPlacementWorksheetUnitOccupant[]>([]);
  const [isRightOpen, setIsRightOpen] = React.useState(true);

  const value = React.useMemo(
    () => ({
      selectedResidents,
      setSelectedResidents,
      isRightOpen,
      setIsRightOpen,
    }),
    [isRightOpen, selectedResidents]
  );

  return <PopupContext.Provider value={value}>{props.children}</PopupContext.Provider>;
};
